import axios from 'axios';
const instance = axios.create({
  baseURL:
    '/news/api/v4/'
});
export default instance;



// WEBPACK FOOTER //
// ./app/web/asset/news-pc/js/axios.js